<button class="absolute top-3.5 right-[8px] z-10" mat-dialog-close>
  <mat-icon class="text-[#9F9F9F]">close</mat-icon>
</button>

<div mat-dialog-title class="!text-[15px] text-center !text-white !px-3">
  {{ 'dialog_advance_aml_protection_triggers.title' | translate }}
</div>

<mat-dialog-content class="!px-3 !pb-3 !max-h-[70vh]">
  <app-advanced-aml-protection-triggers-table></app-advanced-aml-protection-triggers-table>
</mat-dialog-content>


